import { render, staticRenderFns } from "./VerifierSourceCode.vue?vue&type=template&id=40b65531"
import script from "./VerifierSourceCode.vue?vue&type=script&lang=js"
export * from "./VerifierSourceCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports